import request from '@/utils/request'


export function addOtherFileSet(data) {
    return request({
        url: `api/serviceCenter/otherFileSettings/addOtherFileSet`,
        method: 'post',
        data,
    })
}

export function upDateOtherFileSet(data) {
    return request({
        url: `api/serviceCenter/otherFileSettings/upDateOtherFileSet`,
        method: 'post',
        data,
    })
}

export function selectOtherFileSet(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherFileSettings/selectOtherFileSet?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function bathDeleteOtherFileSet(data) {
    return request({
        url: `api/serviceCenter/otherFileSettings/bathDeleteOtherFileSet`,
        method: 'post',
        data,
    })
}



export function setDefaultSet(data) {
    return request({
        url: `api/serviceCenter/otherFileSettings/setDefaultSet?access=${data}`,
        method: 'post',
        data,
    })
}


export function selectAllMaterialInventory(data) {
    return request({
        url: `api/serviceCenter/materialInventory/selectAllMaterialInventory?access=${data}`,
        method: 'post',
        data,
    })
}






